import React from "react";
import GuardLogin from "../../Components/Guard/GuardLogin";
import GuardLayout from "../../Components/Layout/GuardLayout";
import { GuardLanguage } from "../../utils/Languages";

const GuardLoginPage = () => {
  return (
    <GuardLayout
      Heading={GuardLanguage.Login.heading}
      TitleMark={true}
      TitleMarkClassName="event-guard-title-mark"
      TitleClassName="event-guard-title"
      HeadClassName="event-guard-head"
      ExtraclassName="event-guard-panel"
    >
      <GuardLogin />
    </GuardLayout>
  );
};

export default GuardLoginPage;
